var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"button is-primary m-r-5",attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.printWorksheetNew()}}},[_vm._v("\n        "+_vm._s(_vm.$t('keywords.print')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }